export type PhoneCountry = {
  code: string
  name: string
  flag: string
  mask: string
}

/** Mesma lista do login clássico (`auth/login.php`). */
export const PHONE_COUNTRIES: PhoneCountry[] = [
  { code: '+55', name: 'Brasil', flag: 'br', mask: '(##) #####-####' },
  { code: '+1', name: 'Estados Unidos', flag: 'us', mask: '(###) ###-####' },
  { code: '+1', name: 'Canadá', flag: 'ca', mask: '(###) ###-####' },
  { code: '+54', name: 'Argentina', flag: 'ar', mask: '### ###-####' },
  { code: '+56', name: 'Chile', flag: 'cl', mask: '### ###-###' },
  { code: '+57', name: 'Colômbia', flag: 'co', mask: '### ###-####' },
  { code: '+52', name: 'México', flag: 'mx', mask: '### ###-####' },
  { code: '+34', name: 'Espanha', flag: 'es', mask: '### ##-##-##' },
  { code: '+33', name: 'França', flag: 'fr', mask: '## ## ## ## ##' },
  { code: '+49', name: 'Alemanha', flag: 'de', mask: '### ########' },
  { code: '+39', name: 'Itália', flag: 'it', mask: '### ### ####' },
  { code: '+44', name: 'Reino Unido', flag: 'gb', mask: '#### ### ####' },
  { code: '+351', name: 'Portugal', flag: 'pt', mask: '### ### ###' },
]

export function flagUrl(flag: string): string {
  return `https://flagcdn.com/w20/${flag}.png`
}

export function applyPhoneMask(digitsOrMasked: string, mask: string): string {
  const value = digitsOrMasked.replace(/\D/g, '')
  let masked = ''
  let valueIndex = 0
  for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
    if (mask[i] === '#') {
      masked += value[valueIndex]
      valueIndex++
    } else {
      masked += mask[i]
    }
  }
  return masked
}

export function maskPlaceholder(mask: string): string {
  return mask.replace(/#/g, '0')
}
